import { render, staticRenderFns } from "./Detail-Orders.vue?vue&type=template&id=52a0fa33"
import script from "./Detail-Orders.vue?vue&type=script&lang=js"
export * from "./Detail-Orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports